/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Gestion du drag & drop spécifique à la liste des sous rubriques
 */
(function sortableSousRubrique() {
    if ('draggable' in document.createElement('span')) {
        var container = document.querySelector('.js-resultat-sous-rubrique');
        if (container) {
            var spanButtonAlpha = document.querySelector('.js-button-tri-alpha-span');
            if (spanButtonAlpha) {
                spanButtonAlpha.classList.toggle('masquer');
            }
            var buttonAlpha = document.querySelector('.js-button-tri-alpha');
            if (buttonAlpha) {
                buttonAlpha.classList.toggle('masquer');
                buttonAlpha.onclick = function () {
                    triParNom(container);
                };
            }
            var flechesRubriques = document.querySelectorAll('.js-fleche-rubrique');
            if (flechesRubriques) {
                [].forEach.call(flechesRubriques, function (fleche) {
                    fleche.classList.toggle('sr-only');
                });
            }
            var iconsDragDrop = document.querySelectorAll('.js-icon-drag-drop');
            if (iconsDragDrop) {
                [].forEach.call(iconsDragDrop, function (icon) {
                    icon.classList.toggle('masquer');
                });
            }
            // Ajout du drag & drop sur l'élement <ul>
            Sortable.create(
                container, {
                    onUpdate: function (evt/**Event*/) {
                        // Après chaque déplacement on recalcule la position des élements
                        updateOrdreRubriqueFille(evt.to);
                    }
                });
        }
    }
    /**
     * Méthode qui recalcule le "name" des inputs hidden
     * Dans le but de bien réenregistrer l'ordre des rubriques
     * @param to L'element HTML qui contient les élements draggable
     */
    function updateOrdreRubriqueFille(to) {
        if (to) {
            var elements = to.querySelectorAll('.js-rubrique-fille');
            for (var i = 0; i < elements.length; i++) {
                if (elements) {
                    elements[i].name = 'RUBRIQUE_FILLE_CODE#' + i;
                }
            }
        }
    }

    /**
     * Méthode qui permet de trier la liste des sous rubriques par nom
     */
    function triParNom(list) {
        if (list) {
            var items = list.querySelectorAll('li');
            var sortList = [];
            for (var i = items.length - 1; i >= 0; i--) {
                sortList.push(items[i]);
                list.removeChild(items[i]);
            }
            sortList.sort(
                function (a, b) {
                    var c = a.querySelector('.resultat__rubrique__intitule').textContent,
                        d = b.querySelector('.resultat__rubrique__intitule').textContent;
                    return c < d ? -1 : c > d ? 1 : 0;
                });
            for (var i = 0, ln = sortList.length; i < ln; i++) {
                list.appendChild(sortList[i]);
            }
            updateOrdreRubriqueFille(document.querySelector('.js-resultat-sous-rubrique'));
        }
    }
})();

(function initialiserEcranRubrique() {
    var arrayOnglets = [];
    arrayOnglets[0] = 'general';
    arrayOnglets[1] = 'sousrubrique';
    arrayOnglets[2] = 'personnalisation';
    arrayOnglets[3] = 'encadre';
    arrayOnglets[4] = 'contenu';
    arrayOnglets[5] = 'diffusion';
    arrayOnglets[6] = 'referencement';

    const formSaisieRubrique = document.getElementById('js-saisie-rubrique');

    if (formSaisieRubrique) {
        atteindreAncre(formSaisieRubrique.ANCRE.value);
        formSaisieRubrique.TYPE_RUBRIQUE.onchange = displayFieldPageTete;

        ajouterEventListener('action__button-supprimer', 'click', soumettreSuppression);
        ajouterEventListener('action__button-enregistrer', 'click', soumettreFormulaire);
        ajouterEventListener('action__button-copy', 'click', callCopy);
        [].forEach.call(document.querySelectorAll('.js-supprimer-reference'), function (element) {
            var indice = element.getAttribute('data-indice');
            ajouterEventListener(element, 'click', function() {
                soumettreSuppressionFicheReferencee(event, indice );
            });
        });
        [].forEach.call(document.querySelectorAll('.js-apercu-reference'), function (element) {
            var url = element.getAttribute('data-url');
            ajouterEventListener(element, 'click', function() {
                openRub(url, 'apercu' );
            });
        });
        ajouterEventListener('action__button-ajouter-reference', 'click', soumettreAjoutFicheReferencee);
        [].forEach.call(document.querySelectorAll('.js-supprimer-requete'), function (element) {
            var indice = element.getAttribute('data-indice');
            ajouterEventListener(element, 'click', function() {
                soumettreSuppressionRequete(event, indice );
            });
        });
        ajouterEventListener('action__button-ajouter-requete', 'click', soumettreAjoutRequete);
        ajouterEventListener('action__button-apercu', 'click', function () {
            openRub(formSaisieRubrique.URL_APERCU.value);
        });
        ajouterEventListener('action__button-ajouter-sous-rubrique', 'click', function () {
            addSubRubrique(formSaisieRubrique.CODE.value);
        });
        [].forEach.call(document.querySelectorAll('.js-monter-rubrique'), function (element) {
            var indice = element.getAttribute('data-indice');
            ajouterEventListener(element, 'click', function() {
                soumettreRemonterRubriqueFille(indice);
            });
        });
        [].forEach.call(document.querySelectorAll('.js-descendre-rubrique'), function (element) {
            var indice = element.getAttribute('data-indice');
            ajouterEventListener(element, 'click', function() {
                soumettreBaisserRubriqueFille(indice);
            });
        });

        ajouterEventListener(document.querySelector('.js-slug__button-customize'), 'click', personnaliserSlug);
        ajouterEventListener(document.querySelector('.js-slug__button-refresh'), 'click', genererUrlRubrique);

        ajouterEventListener('li-general', 'click', function () {
            activeOnglet(0);
        });
        ajouterEventListener('li-sousrubrique', 'click', function () {
            activeOnglet(1);
        });
        ajouterEventListener('li-personnalisation', 'click', function () {
            activeOnglet(2);
        });
        ajouterEventListener('li-encadre', 'click', function () {
            activeOnglet(3);
        });
        ajouterEventListener('li-contenu', 'click', function () {
            activeOnglet(4);
        });
        ajouterEventListener('li-diffusion', 'click', function () {
            activeOnglet(5);
        });
        ajouterEventListener('li-referencement', 'click', function () {
            activeOnglet(6);
        });
        [].forEach.call(document.querySelectorAll('.js-openRub'), function (element) {
            ajouterEventListener(element, 'click', function(event) {
                openRub(element.href);
                event.preventDefault();
            });
        });
    }

    function activeOnglet(indiceOnglet, ancre) {
        var nomOnglet = '';
        for (var i = 0; i < arrayOnglets.length;i++) {
            nomOnglet = arrayOnglets[i];

            if (i == indiceOnglet) // onglet selectionne
            {
                if (document.getElementById('li-' + nomOnglet)) {
                    document.getElementById('li-' + nomOnglet).className = 'active';
                }

                if (document.getElementById('div-' + nomOnglet)) {
                    document.getElementById('div-' + nomOnglet).style.display = 'block';
                }
            } else {
                if (document.getElementById('li-' + nomOnglet)) {
                    document.getElementById('li-' + nomOnglet).className = '';
                }

                if (document.getElementById('div-' + nomOnglet)) {
                    document.getElementById('div-' + nomOnglet).style.display = 'none';
                }
            }
        }
        if (indiceOnglet == 0) {
            displayFieldPageTete();
        }
        if (ancre) {
            window.location.href = '#' + ancre;
        }
    }


    function removePreview() {
        const previewUrl = document.querySelector('.js-previewUrl');
        if (previewUrl) {
            previewUrl.value = '';
        }
        const previewAction = document.querySelector('.js-previewAction');
        if (previewAction) {
            previewAction.style.display = 'none';
        }
    }

    var codeRubriqueMere = document.querySelector('#CODE_RUBRIQUE_MERE'),
        typeRubrique = document.querySelector('[name=TYPE_RUBRIQUE]');
    if (codeRubriqueMere) {
        codeRubriqueMere.addEventListener('change', removePreview);
    }
    if (typeRubrique) {
        typeRubrique.addEventListener('change', removePreview);
    }

    function displayFieldPageTete() {
        //on recuperer la valeur selectionnee
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        var oTypeRubrique = formSaisieRubrique.TYPE_RUBRIQUE;
        var divs = document.getElementsByClassName('page-accueil');
        for (var i = 0; i < divs.length; i++) {
            divs[i].style.display = 'none';
            var inputs = divs[i].getElementsByTagName('input');
            for(var j = 0; j < inputs.length;j++) {
                if (inputs[j].getAttribute('required')) {
                    inputs[j].removeAttribute('required');
                }
            }
            var selects = divs[i].getElementsByTagName('select');
            for(var j = 0; j < selects.length;j++) {
                if (selects[j].getAttribute('required')) {
                    selects[j].removeAttribute('required');
                }
            }
        }
        var div = document.getElementById('page-accueil-' + oTypeRubrique.value);
        if (div) {
            div.style.display = 'inline';
            inputs = div.getElementsByTagName('input');
            for(var i = 0; i < inputs.length;i++) {
                if (inputs[i].getAttribute('data-required')) {
                    inputs[i].setAttribute('required',true);
                }
            }
            selects = div.getElementsByTagName('select');
            for(var i = 0; i < selects.length;i++) {
                if (selects[i].getAttribute('data-required')) {
                    selects[i].setAttribute('required',true);
                }
            }
        }
        if (oTypeRubrique.value === '0001') {
            loadPageTeteFiche();
        }
    }

    function ajouterEventListener(target, evenement, fonction ) {
        var elem = target;
        if ( typeof (target) === 'string' || target instanceof String ) {
            elem = document.getElementById(target);
        }
        if (elem) {
            elem.addEventListener(evenement, fonction);
        }
    }

    function atteindreAncre(ancre) {
        if (ancre != 'null' && ancre != '') {
            var breaked = false;
            for (var i = 0;i < arrayOnglets.length;i++) {
                if (ancre.indexOf(arrayOnglets[i]) == 0) {
                    activeOnglet(i,ancre);
                    breaked = true;
                    break;
                }
            }
            if (!breaked) {
                activeOnglet(0);
            }
        } else {
            activeOnglet(0);
        }
    }

    function personnaliserSlug() {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'URL_CUSTOMIZE';
        formSaisieRubrique.submit();
    }

    function genererUrlRubrique() {
        var titre = document.querySelector('#INTITULE').value;
        var slugAuto = document.querySelector('input[name="SLUG_AUTO"]');
        var codeRubrique = document.querySelector('#CODE').value;
        var codeRubriqueMere = document.querySelector('#CODE_RUBRIQUE_MERE').value;
        var typePageAccueil = document.querySelector('#TYPE_RUBRIQUE').value;
        var slug = document.querySelector('#DISPLAY-SLUG');
        var slugValue = slug ? slug.value : '';
        var urlErrorSection = document.querySelector('.js-section-urlError');
        var incErrorSection = document.querySelector('.js-url__check-slug-inc');
        var checkSlugOk = document.querySelector('.js-url__check-slug-ok');
        jQuery.ajax({
            type: 'GET',
            url: '/bo/url/section/url',
            data: {'codeRubrique': codeRubrique,'codeRubriqueMere': codeRubriqueMere,'slug': slugValue, 'intitule': titre, 'typePageAccueil': typePageAccueil},
            success: function (data) {
                var hostElement = document.querySelector('.js-url__custom-host');
                slug.value = data.slug;
                slugAuto.value = data.slugAuto;
                if(data.host !== data.shortenHost) {
                    hostElement.innerHTML = data.shortenHost + '/';
                    hostElement.title = data.host;
                }  else {
                    hostElement.innerHTML = data.host + '/';
                }
                urlErrorSection.classList.add('masquer');
                if(data.computedSlug && slug.value.toLowerCase() !== data.computedSlug.toLowerCase()) {
                    incErrorSection.classList.remove('masquer');
                    checkSlugOk.classList.add('masquer');
                    var incrementedSlug = document.querySelector('.js-url__error_slug_inc');
                    incrementedSlug.innerHTML = data.computedSlug;
                }else {
                    incErrorSection.classList.add('masquer');
                    checkSlugOk.classList.remove('masquer');
                }
                displaySlugInfo();
            },
            error: function (jqXHR) {
                checkSlugOk.classList.add('masquer');
                urlErrorSection.classList.remove('masquer');
                urlErrorSection.innerHTML = jqXHR.responseJSON.message;
                displaySlugInfo();
            }
        });
    }

    /**
     * Affichage du bloc d'info si slug déphasé par rapport au titre
     */
    function displaySlugInfo() {
        var slug = document.getElementById('DISPLAY-SLUG');
        var slugAuto = document.querySelector('input[name="SLUG_AUTO"]');
        var updatedSlugElement = document.querySelector('.js-url__slug-updated');
        var displayInfo = slug && slugAuto && slug.value !== slugAuto.value;
        if(updatedSlugElement) {
            displayInfo ? updatedSlugElement.classList.remove('masquer') : updatedSlugElement.classList.add('masquer');
        }
    }

    function addSubRubrique(code) {
        var newWindow = window.open('/servlet/com.jsbsoft.jtf.core.SG?EXT=core&PROC=SAISIE_RUBRIQUE&ACTION=AJOUTER&CODE_RUBRIQUE_MERE=' + code);
        newWindow.focus();
    }

    function openRub(url, name) {
        window.open(url, name, '');
    }

    function soumettreSuppressionRequete(event,i) {
        var that = jQuery(event.target);
        event.preventDefault();
        jQuery('<div></div>')
            .html( that.data('confirmation'))
            .dialog({
                buttons: [{
                    text: LOCALE_BO.ok,
                    click: function() {
                        jQuery(this).dialog('close');
                        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
                        formSaisieRubrique.ACTION.value = 'SUPPRIMER_REQUETE#' + i;
                        formSaisieRubrique.submit();
                    }
                },{
                    text: LOCALE_BO.fermer,
                    click: function() {
                        jQuery(this).dialog('close');
                    }
                }],
                title: LOCALE_BO.confirmer
            });
    }

    function soumettreAjoutRequete() {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'AJOUTER_REQUETE';
        formSaisieRubrique.submit();
    }

    function soumettreRemonterRubriqueFille(i) {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'REMONTER_RUBRIQUE_FILLE#' + i;
        formSaisieRubrique.submit();
    }

    function soumettreBaisserRubriqueFille(i) {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'BAISSER_RUBRIQUE_FILLE#' + i;
        formSaisieRubrique.submit();
    }

    function soumettreSuppressionFicheReferencee(event, i) {
        var that = jQuery(event.target);
        event.preventDefault();
        jQuery('<div></div>')
            .html( that.data('confirmation'))
            .dialog({
                buttons: [{
                    text: LOCALE_BO.ok,
                    click: function() {
                        jQuery(this).dialog('close');
                        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
                        formSaisieRubrique.ACTION.value = 'SUPPRIMER_FICHE_REFERENCEE#' + i;
                        formSaisieRubrique.submit();
                    }
                },{
                    text: LOCALE_BO.fermer,
                    click: function() {
                        jQuery(this).dialog('close');
                    }
                }],
                title: LOCALE_BO.confirmer
            });
    }

    function soumettreAjoutFicheReferencee ( ) {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'AJOUTER_FICHE_REFERENCEE';
        formSaisieRubrique.submit();
    }

    function soumettreSuppression() {
        if (this.dataset['confirmdelete']) {
            $ksup('<div>')
                .html(this.dataset['confirmdelete']).dialog(
                    {
                        buttons: [{
                            text: LOCALE_BO.ok,
                            click: function () {
                                submitDelete();
                                $ksup(this).dialog('close');
                            }
                        }, {
                            text: LOCALE_BO.fermer,
                            click: function () {
                                $ksup(this).dialog('close');
                            }
                        }],
                        title: LOCALE_BO.confirmer
                    });
        } else {
            submitDelete();
        }
    }

    function submitDelete() {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'SUPPRIMER';
        formSaisieRubrique.submit();
    }

    function soumettreFormulaire() {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        if(jQuery(formSaisieRubrique).valid()) {
            var saveButton = document.getElementById('action__button-enregistrer');
            if (saveButton.getAttribute('data-newSection')) {
                sendForm();
            }else{
                getAndDiplayNbImpacts();
            }
        }
    }

    /**
     * Méthode appelée au clique sur le bouton dupliquer
     */
    function callCopy() {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'COPY';
        document.getElementById('js-section-code').value = document.getElementById('CODE').value;
        formSaisieRubrique.submit();
    }

    /**
     * Submit du formulaire.
     */
    function sendForm() {
        const formSaisieRubrique = document.getElementById('js-saisie-rubrique');
        formSaisieRubrique.ACTION.value = 'VALIDER';
        formSaisieRubrique.submit();
    }

    /**
     * Récupère et affiche les impacts, si pas d'impact, le formulaire est envoyé.
     */
    function getAndDiplayNbImpacts() {
        var sectionData = getDataForImpacts();
        jQuery.ajax({
            type: 'GET',
            url: '/bo/url/impact/rubrique',
            dataType: 'json',
            data: sectionData,
            success:function(data) {
                var nbImpacts = parseInt(data, 10);
                if(nbImpacts === 0) {
                    sendForm();
                }else{
                    var libelle = LOCALE_BO.sectionsImpacts.replace('%d', data);
                    displayCheckUrlImpact(libelle);
                }
            },
            error: function (jqXHR) {
                sendForm();
            }
        });
    }

    /**
     * Récupération des données nécessaire au calcul d'impact de rubriques.
     * @returns les données nécessaire au calcul d'impact de rubriques
     */
    function getDataForImpacts() {
        var sectionData = {};

        sectionData.codeRubrique = document.querySelector('[name="CODE"]').value;
        sectionData.codeRubriqueMere = document.getElementById('CODE_RUBRIQUE_MERE').value;
        sectionData.slug = document.getElementById('DISPLAY-SLUG').value;

        var hasWelcomePage = false;
        var typeRubrique = document.getElementById('TYPE_RUBRIQUE').value;
        if(typeRubrique !== '0000') {
            var pageAccueilDiv = document.querySelector('#page-accueil-' + typeRubrique);
            if(pageAccueilDiv) {
                var requiredSons = pageAccueilDiv.querySelectorAll('input[data-required="true"]');
                var allFilled = [].slice.call(requiredSons).reduce(function (accumulator, requiredSon) {
                    return accumulator && !!requiredSon.value;
                }, true);
                hasWelcomePage = allFilled;
            }
        }

        sectionData.hasWelcomePage = hasWelcomePage;

        return sectionData;
    }

    /**
     * Crée et affiche la popin des impacts de rubriques.
     * @param libelle le libellé à afficher
     */
    function displayCheckUrlImpact(libelle) {
        jQuery('<div>')
            .html(libelle)
            .dialog({
                buttons: [{
                    text: LOCALE_BO.ok,
                    click: function () {
                        jQuery(this).dialog('close');
                        sendForm();
                    }
                }, {
                    text: LOCALE_BO.fermer,
                    click: function () {
                        jQuery(this).dialog('close');
                    }
                }],
                title: LOCALE_BO.confirmer
            });
    }

    /**
     * Fonctions pour le type de page de tête "Fiche".
     */
    /**
     * Action d'ouverture/fermeture du block de création de fiche.
     */
    function displayHideCreationContentBlock() {
        const creationContentElement = document.getElementById('js-creation-content-block');
        const flagCreationPageTete = document.getElementById('js-creation-page-tete');
        const kmonoselectPageTete = document.getElementById('kMonoSelectCODE_PAGE_TETE');
        const codeObjetPageTete = document.getElementById('CODE_OBJET_PAGE_DE_TETE');
        const titrePageTete = document.getElementById('TITRE_PAGE_TETE');
        if (creationContentElement.style.display === 'none') {
            codeObjetPageTete.setAttribute('data-required',true);
            codeObjetPageTete.setAttribute('required',true);
            titrePageTete.setAttribute('data-required',true);
            titrePageTete.setAttribute('required',true);
            creationContentElement.style.display = '';
            flagCreationPageTete.value = '1';
            disableChildren(kmonoselectPageTete);
        } else {
            creationContentElement.style.display = 'none';
            codeObjetPageTete.setAttribute('data-required',false);
            codeObjetPageTete.setAttribute('required',false);
            document.getElementById('CODE_OBJET_PAGE_DE_TETE-error')?.remove();
            titrePageTete.setAttribute('data-required',false);
            titrePageTete.setAttribute('required',false);
            document.getElementById('TITRE_PAGE_TETE-error')?.remove();
            titrePageTete.value = '';
            flagCreationPageTete.value = '0';
            enableChildren(kmonoselectPageTete);
        }
    }

    /**
     * Activation des enfants d'un kmonoselect.
     */
    function enableChildren(kmonoselectPageTete) {
        var selectKmonoSelectChildrenArray = selectKmonoSelectChildren(kmonoselectPageTete);
        var isFilled = false;
        for (var elementIndex in selectKmonoSelectChildrenArray) {
            var element = selectKmonoSelectChildrenArray[elementIndex];
            if (!element.className) {
                continue;
            }
            if (element.className.lastIndexOf('kmonoselect-field') > -1) {
                isFilled = element.className.lastIndexOf('placeholder') > -1;
            }
            var index = element.className.lastIndexOf(' ui-state-disabled');
            if (index !== -1
                && (element.className.lastIndexOf('kmonoselect-clear-button') === -1 || !isFilled)) {
                element.className = element.className.slice(0, index);
            }
        }
    }

    /**
     * Désactivation des enfants d'un kmonoselect.
     */
    function disableChildren(kmonoselectPageTete) {
        var selectKmonoSelectChildrenArray = selectKmonoSelectChildren(kmonoselectPageTete);
        for (var elementIndex in selectKmonoSelectChildrenArray) {
            var element = selectKmonoSelectChildrenArray[elementIndex];
            if (element.className && element.className.lastIndexOf('ui-state-disabled') === -1) {
                element.className = element.className + ' ui-state-disabled ui-button-disabled';
            }
        }
    }
    /**
     * Sélection des enfants d'un kmonoselect.
     * @param kmonoselect
     * @returns {string|Array.<T>|*}
     */
    function selectKmonoSelectChildren(kmonoselect) {
        var fields = Array.from(kmonoselect.getElementsByClassName('kmonoselect-field'));
        var buttons = Array.from(kmonoselect.getElementsByClassName('kmonoselect-button'));
        return fields.concat(buttons);
    }

    function loadPageTeteFiche() {
        var creationContentElement = document.getElementById('js-action-creation-content');
        var cancelContentElement = document.getElementById('js-cancel-content-creation');
        if (creationContentElement) {
            creationContentElement.addEventListener('click', displayHideCreationContentBlock);
        }
        if (cancelContentElement) {
            cancelContentElement.addEventListener('click', displayHideCreationContentBlock);
        }
    }
})();
